import { axiosV1 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

type FactorialAuthorizeUrlResponse = {
  authorizeUrl?: string;
};

export const getFactorialAuthorizeUrl = async (): Promise<string> => {
  const { data } = await axiosV1.get('/integration/factorial/authorize-url');
  const decodedData = (await decryptResponse(data)) as FactorialAuthorizeUrlResponse;

  return decodedData?.authorizeUrl ?? '';
};
